import { z } from 'zod';
import { SubscriptionSaleType, subscriptionSaleTypeSchema } from './subscriptionSaleType.js';
export const SALE_TYPE_RECENCY_MONTHS = 6;
export const saleTypeReasonSchema = z.enum([
    'HoldsCredits',
    'HoldsRunningPackage',
    'RecentContract',
    'NoRecentContract',
]);
export const SaleTypeReason = saleTypeReasonSchema.enum;
export const saleTypeEligibilitySchema = z.object({
    permitted: subscriptionSaleTypeSchema.array(),
    recommended: subscriptionSaleTypeSchema.nullable(),
    reason: saleTypeReasonSchema,
    lastActivityAt: z.iso.datetime().nullable(),
});
export const deriveSaleTypeEligibility = (history, asOf) => {
    const lastActivityAt = history.lastActivityAt ? new Date(history.lastActivityAt) : null;
    const reason = reasonFor(history, lastActivityAt, asOf);
    return {
        ...ELIGIBILITY_BY_REASON[reason],
        reason,
        lastActivityAt: lastActivityAt?.toISOString() ?? null,
    };
};
const NOTHING_TO_MIGRATE = [SubscriptionSaleType.NewSale, SubscriptionSaleType.Prolongation];
const ELIGIBILITY_BY_REASON = {
    [SaleTypeReason.HoldsCredits]: {
        permitted: [SubscriptionSaleType.Migration],
        recommended: SubscriptionSaleType.Migration,
    },
    [SaleTypeReason.HoldsRunningPackage]: { permitted: NOTHING_TO_MIGRATE, recommended: null },
    [SaleTypeReason.RecentContract]: { permitted: NOTHING_TO_MIGRATE, recommended: SubscriptionSaleType.Prolongation },
    [SaleTypeReason.NoRecentContract]: { permitted: NOTHING_TO_MIGRATE, recommended: SubscriptionSaleType.NewSale },
};
const reasonFor = (history, lastActivityAt, asOf) => {
    if (history.remainingCredits > 0 || history.remainingMonetaryValue > 0) {
        return SaleTypeReason.HoldsCredits;
    }
    if (history.hasRunningOldPackage) {
        return SaleTypeReason.HoldsRunningPackage;
    }
    return lastActivityAt && lastActivityAt >= recencyThreshold(asOf)
        ? SaleTypeReason.RecentContract
        : SaleTypeReason.NoRecentContract;
};
// Shifting the month keeps the day, which rolls into the next month when the target month is shorter: 31 August minus
// six months asks for 31 February and lands on 3 March, shortening the window by three days. The day is clamped to the
// target month instead. Done in UTC because the comparison is between instants, and the local-time setters would move
// the boundary by an hour across a daylight-saving change.
const recencyThreshold = (asOf) => {
    const year = asOf.getUTCFullYear();
    const month = asOf.getUTCMonth() - SALE_TYPE_RECENCY_MONTHS;
    const day = Math.min(asOf.getUTCDate(), daysInUtcMonth(year, month));
    return new Date(Date.UTC(year, month, day, asOf.getUTCHours(), asOf.getUTCMinutes(), asOf.getUTCSeconds()));
};
const daysInUtcMonth = (year, month) => new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
export const isSaleTypePermitted = (eligibility, saleType) => eligibility.permitted.includes(saleType);
